<template>
  <v-layout column>

      <update-eta-dialog :load-id="loadId"
                         :type="etaUpdateToType"
                         @refresh="refreshCurrentLoad()"
                         v-model="showUpdateETADialog">
      </update-eta-dialog>

      <pickup-load-dialog v-model="showPickupDialog"
                          @refresh="refreshCurrentLoad()"
                          :load-id="_.get(currentLoad, 'humanId', null)">
      </pickup-load-dialog>

      <deliver-load-dialog v-model="showDeliverDialog"
                           @refresh="refreshCurrentLoad()"
                           :company="company"
                           :load="currentLoad">
      </deliver-load-dialog>

      <upload-bill-of-lading-dialog v-model="showAttachBillOfLadingDialog"
                                    :load-id="_.get(currentLoad, 'humanId', null)"
                                    @refresh="refreshCurrentLoad">
      </upload-bill-of-lading-dialog>

      <cancel-load-dialog  v-model="cancelModal"
                           @refresh="removeLoad"
                           :listing-human-id="loadGroupId"
                           :booked-load-id="_.get(currentLoad, 'id', null)"
                           :load-id="_.get(currentLoad, 'humanId', null)">
      </cancel-load-dialog>

      <v-repeat-load-group-dialog v-if="currentLoad"
                                  v-model="showCopyLoadDialog"
                                  :loadGroupId="loadGroupId"
                                  :sponsor="listingSponsorName"
                                  :origin="listing | originName"
                                  :destination="listing | destinationName"
                                  :count="listing.loadCount || 1"
                                  :isMobile="isMobile"
                                  :loading="loadingBtn"
                                  :company="company"
                                  :load-group="listing"
                                  @cancel="closeCopyLoadDialog"
                                  @newLoad="closeCopyLoadDialog(true)">
      </v-repeat-load-group-dialog>

      <v-dialog v-model="showAttachPhotoDialog" max-width="400">
        <v-card>
          <v-card-title class="title">
            <v-toolbar>
              <v-toolbar-side-icon><v-icon color="primary">add_a_photo</v-icon></v-toolbar-side-icon>
              <v-toolbar-title>Attach Photo</v-toolbar-title>
            </v-toolbar>
          </v-card-title>
          <v-layout column class="px-3">
            <v-layout column>
              <v-text-field label="Caption or Name" v-model="attachedPhotoName" required
                            :rules="[() => attachedPhotoName.length > 0 || 'Required field']"/>
              <v-progress-linear v-if="uploadProgressPercentage !== null"
                                 class="mt-0 pt-0"
                                 v-model="uploadProgressPercentage">
              </v-progress-linear>
            </v-layout>
            <input type="file" style="" ref="photoAttachment"
                   hidden @change="processPhotoAttachment($event)"/>
            <v-btn class="primary" @click="openPhotoAttachmentSelector"
                   :disabled="_.isEmpty(attachedPhotoName)">
              Select Photo
            </v-btn>
          </v-layout>
          <v-card-actions>
            <v-spacer />
            <v-btn flat color="accent" @click="showAttachPhotoDialog = false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="openPhotoHelpDialog" max-width="600">
        <v-card>
          <v-card-title class="headline lighten-2 py-0 justify-end pr-0"
                        primary-title>
            <v-btn icon color="primary" small
                   @click.native="openPhotoHelpDialog = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <p class="mb-1">
              Upload a picture of anything which might make communication faster and easier. <br />
              Consider things that the customer, the stockyard, or the carrier might want to know:
            </p>
            <ul>
              <li>Auction load card</li>
              <li>Sick/injured animals</li>
              <li>Your flat tire</li>
              <li>The gate attendant</li>
              <li>Traffic jam</li>
              <li>A nearby building (if you're lost)</li>
            </ul>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="showTimelineDialog"
        lazy
        :max-width="$vuetify.breakpoint.smAndDown ? '90%' : '600px'">
        <v-card>
          <v-card-title class="title">
            <span v-if="timelineDialogBid"> {{ $t('load-detail.', {bidHumanId: timelineDialogBid.humanId} ) }} </span>
            <span v-if="timelineDialogSettlement">{{timelineDialogSettlement.description}}
          payable to {{timelineDialogSettlement.paidToCompanyName}}</span>
            Settlement timeline <span v-if="loadingData"> [ ... loading ]</span>
          </v-card-title>
          <v-layout row v-if="timelineDialogSettlement" class="px-4 py-2">
            <v-layout column>
              <v-flex>
                <v-btn-toggle class="mb-2"
                              mandatory
                              v-model="viewToggle">
                  <v-btn flat value="text">
                    <span>Text Message</span>
                    <v-icon>textsms</v-icon>
                  </v-btn>
                  <v-btn flat value="file">
                    <span>Upload File</span>
                    <v-icon>attach_file</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </v-flex>

              <v-card>
                <div class="pa-3">
                  <v-layout row>
                    <template v-if="viewToggle === 'text'">
                      <v-flex  sm10 xs8>
                        <v-textarea block v-model="settlementText"
                                    :rows="2"
                                    label="Type something...">
                        </v-textarea>
                      </v-flex>
                      <v-spacer />
                      <v-flex sm2 xs4>
                        <v-btn block class="mr-0 px-0"
                               :loading="loadingBtn" :disabled="loadingBtn"
                               @click="sendSettlementMessage(timelineDialogSettlement.id)">
                          Send
                        </v-btn>
                      </v-flex>
                    </template>
                    <template v-else>
                      <v-flex sm9 xs8>
                        <v-textarea block v-model="settlementText"
                                    :rows="2"
                                    label="Type something...">
                        </v-textarea>
                        <input type="file" style="" ref="settlementAttachment" hidden
                               @change="processSettlementAttachment($event,
                           timelineDialogSettlement.id)"/>
                      </v-flex>
                      <v-flex sm3 xs4>
                        <v-btn class="primary ml-0"
                               @click="openFileSelector('settlementAttachment')"
                               :disabled="_.isEmpty(settlementText)">
                          Select File
                        </v-btn>
                      </v-flex>
                    </template>
                  </v-layout>
                </div>
              </v-card>

            </v-layout>

          </v-layout>
          <v-layout column class="px-3">
            <div class="timeline-section"
                 :class="{'text-md-center text-lg-center text-sm-center pt-4': loadingData}">
              <timeline v-if="dialogTimeline && !loadingData"
                        show-time
                        :timeline-object="dialogTimeline"></timeline>
              <v-progress-circular v-if="loadingData"
                                   indeterminate color="primary">
              </v-progress-circular>
            </div>
          </v-layout>
          <v-card-actions>
            <v-spacer />
            <v-btn flat color="accent"
                   @click="closeTimelineDialog">
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-layout wrap class="pb-2">
        <v-layout align-center justify-start v-if="!embedded">
          <v-chip label :color="progressIcon.color" text-color="white">
            <v-icon class="mr-2">{{ progressIcon.icon }}</v-icon>
          </v-chip>
        </v-layout>
        <v-toolbar :extended="isMobile" :dense="!isMobile" flat
                   v-if="embedded" height="56">
          <v-toolbar-side-icon @click="openCopyLoadDialog" v-if="isProducerWithPermissions">
            <v-icon color="accent">redo</v-icon>
          </v-toolbar-side-icon>

          <template v-if="isMobile" slot="extension">
            <v-btn flat @click="openBillOfLading"
                   v-if="_.get(currentLoad, 'billOfLading.link', false)">
              <v-layout column>
                <v-icon color="primary">attachment</v-icon>
                <span class="ml-1 primary--text">{{ $t('terms.bill-of-lading') }}</span>
              </v-layout>
            </v-btn>
            <v-btn v-if="currentLoad" :href="gMapsLink" target="_blank" flat>
              <v-layout column>
                <v-icon color="primary">map</v-icon>
                <span class="ml-1 primary--text">View on Google Map</span>
              </v-layout>
            </v-btn>
            <v-btn flat :loading="loadingBtn" :disabled="loadingBtn"
                   @click="checkIn">
              <v-layout column>
                <v-icon color="primary">pin_drop</v-icon>
                <span class="ml-1 primary--text">Checkin</span>
              </v-layout>
            </v-btn>
          </template>

          <v-toolbar-title v-else class="font-weight-bold">
            {{ currentLoad.humanId }}
          </v-toolbar-title>
          <v-spacer/>
          <v-toolbar-items>
            <template v-if="!isMobile">
              <v-btn small flat
                     :loading="loadingBtn"
                     color="primary" @click="refreshCurrentLoad">
                <v-layout column>
                  <v-icon>refresh</v-icon>
                  Reload
                </v-layout>
              </v-btn>
              <v-btn flat @click="openBillOfLading"
                     v-if="_.get(currentLoad, 'billOfLading.link', false)">
                <v-layout column>
                  <v-icon color="primary">attachment</v-icon>
                  <span class="ml-1 primary--text">{{ $t('terms.bill-of-lading') }}</span>
                </v-layout>
              </v-btn>
              <v-btn v-if="currentLoad" :href="gMapsLink" target="_blank" flat>
                <v-layout column>
                  <v-icon color="primary">map</v-icon>
                  <span class="ml-1 primary--text">Google Maps</span>
                </v-layout>
              </v-btn>
              <v-btn flat :loading="loadingBtn" :disabled="loadingBtn"
                     @click="checkIn">
                <v-layout column>
                  <v-icon color="primary">pin_drop</v-icon>
                  <span class="ml-1 primary--text">Checkin</span>
                </v-layout>
              </v-btn>
            </template>
            <template v-else>
              <v-btn small flat
                     :loading="loadingBtn"
                     color="primary" @click="refreshCurrentLoad">
                <v-layout column>
                  <v-icon>refresh</v-icon>
                  Reload
                </v-layout>
              </v-btn>
            </template>
            <v-menu v-if="canCancel ||
             ((isScheduled || isInTransit || isDelivered) && canUpdateLoadProgress )">
              <v-btn slot="activator"
                     flat
                     color="accent"
                     dark>
                <v-layout column>
                  <v-icon>more_horiz</v-icon>
                  Update
                </v-layout>
              </v-btn>

              <v-list>
                <v-list-tile v-if="isScheduled && canUpdateLoadProgress"
                             @click="showPickupDialog = true">
                  <v-list-tile-avatar>
                    <v-icon color="primary">
                      arrow_upward
                    </v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-title>
                    Pick Up
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-if="isInTransit && canUpdateLoadProgress"
                             @click="openDeliverDialog()">
                  <v-list-tile-avatar>
                    <v-icon color="primary">
                      play_for_work
                    </v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-title>
                    Deliver
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-if="isScheduled && canUpdateLoadProgress"
                             @click="openUpdateETADialog('pickup')">
                  <v-list-tile-avatar>
                    <v-icon color="primary">drive_eta</v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-title>
                    Update Pick up ETA
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-if="isInTransit && canUpdateLoadProgress"
                             @click="openUpdateETADialog('delivery')">
                  <v-list-tile-avatar>
                    <v-icon color="primary">drive_eta</v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-title>
                    Update Delivery ETA
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-if="canCancel"
                             @click="displayCancelModal()">
                  <v-list-tile-avatar>
                    <v-icon color="accent">cancel</v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-title>
                    Cancel Truck
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-if="isDelivered && canUpdateLoadProgress"
                             @click="showAttachBillOfLadingDialog = true">
                  <v-list-tile-avatar>
                    <v-icon color="primary">
                      attachment
                    </v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-title>
                    Upload {{ $t('terms.bill-of-lading') }}
                  </v-list-tile-title>
                </v-list-tile>

              </v-list>
            </v-menu>
          </v-toolbar-items>

        </v-toolbar>
      </v-layout>
      <div :class="{'scroll-section': !isMobile}">
        <v-layout wrap class="mt-2" v-if="currentLoad">
          <v-flex xs12 md6>
            <span class="title font-weight-bold">Pickup: {{ notificationPickupTime.value }}</span>
            <span class="body-2 font-italic">({{ notificationPickupTime.providedBy }})</span>
          </v-flex>
          <v-flex xs12 md6 class="title font-weight-bold">
            <span class="title font-weight-bold">Delivery: {{ notificationDeliveryTime.value }}</span>
            <span class="body-2 font-italic">({{ notificationDeliveryTime.providedBy }})</span>
          </v-flex>
        </v-layout>

        <progress-arrows class="hidden-xs-only"
                         v-if="currentLoad"
                         :status="currentLoadStatus"
                         :show-paid="!isTruckingDriverViewing"/>

        <v-layout align-center justify-center row>
          <v-flex md6 xs12 :class="{'mr-4': !isMobile}">
            <v-card>
              <v-list class="py-0" :class="{'desktop-list': !isMobile}">

                <v-list-tile
                  @click="hasCompanyProfile ?
                $router.push({
                  name: 'company.settings',
                  params: { id: loadModel.customerCompany(currentLoad).id }
                  }) : null"
                  v-if="loadModel.customerName(currentLoad)">
                  <!--v-list-tile-avatar>
                    <v-icon>business</v-icon>
                  </v-list-tile-avatar -->

                  <v-list-tile-content>
                    <v-list-tile-title>
                      <b>Customer</b>
                    </v-list-tile-title>
                    <v-list-tile-sub-title
                      v-if="hasCompanyProfile">
                      <v-icon>business</v-icon>
                      {{loadModel.customerName(currentLoad)}}
                    </v-list-tile-sub-title>

                    <v-list-tile-sub-title v-else>
                      {{loadModel.customerName(currentLoad)}}
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-list-group v-model="reqListGroup">
                  <v-list-tile slot="activator">
                    <v-list-tile-content>
                      <v-list-tile-title>
                        <b>Requirements</b>
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile v-if="requireWashout">
                    <v-list-tile-action>
                      <icon-base width="35" height="35" icon-color="#352208"
                                 icon-name="hose"><icon-hose /></icon-base>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>Washout</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile v-if="requireWoodChips">
                    <v-list-tile-action>
                      <icon-base width="35" height="35" icon-color="#352208"
                                 viewBox="0 0 5 5" icon-name="wood">
                        <icon-wood />
                      </icon-base>
                    </v-list-tile-action>

                    <v-list-tile-content>
                      <v-list-tile-title>Wood Chips</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile v-if="requireWeatherboards">
                    <v-list-tile-action>
                      <icon-base width="35" height="35" icon-name="cold" icon-color="#352208">
                        <icon-cold />
                      </icon-base>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>Weatherboards</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title>
                        See instructions in load history
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list-group>

                <v-list-group>
                  <v-list-tile slot="activator">
                    <v-list-tile-content>
                      <v-list-tile-title>
                        <b v-if="isDispatched">Dispatcher</b>
                        <b v-else>{{$t('components.load-details.self-contracted')}}</b>
                      </v-list-tile-title>
                      <v-list-tile-sub-title>
                        {{listingCompany.name}}
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-flex style="padding-left: 10px;" v-if="isListingCompanyAdminViewing">
                    <v-btn @click="$router.push({ path: `/companies/${listingCompany.id}/profile`})">
                      <v-icon left>business</v-icon>
                      {{ listingCompany.name }} Profile
                    </v-btn>
                  </v-flex>

                  <company-profile-card v-if="listingCompanyProfile && currentLoad"
                                        :company-profile="listingCompanyProfile"
                                        :load="currentLoad"
                                        :role="LoadCompanyRole.Producer">
                  </company-profile-card>

                </v-list-group>

                <v-list-group v-if="truckingCompany && truckingCompany.id">
                  <v-list-tile slot="activator">
                    <v-list-tile-content>
                      <v-list-tile-title>
                        <b>Carrier</b>
                      </v-list-tile-title>
                      <v-list-tile-sub-title>
                        {{truckingCompany.name}}
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-flex style="padding-left: 10px;" v-if="isTruckingAdminViewing">
                    <v-btn  @click="$router.push({ path: `/companies/${truckingCompany.id}/profile`})">
                      <v-icon left>business</v-icon>
                      {{ truckingCompany.name }} Profile
                    </v-btn>
                  </v-flex>
                  <company-profile-card v-if="truckingCompanyProfile && currentLoad"
                                        :company-profile="truckingCompanyProfile"
                                        :load="currentLoad"
                                        :role="LoadCompanyRole.Carrier">
                  </company-profile-card>
                </v-list-group>
                <v-list-tile v-else>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <b>Carrier</b>
                    </v-list-tile-title>
                    <v-list-tile-sub-title>
                      {{haulingCompany.name}}
                      <dispatcher-info v-if="assignedVendor"
                                       :company="company"
                                       :vendor-dispatcher="assignedVendor"
                                       fab></dispatcher-info>
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-list-group>
                  <v-list-tile slot="activator">
                    <v-list-tile-content>
                      <v-list-tile-title>
                        <b>Origin</b>
                      </v-list-tile-title>
                      <v-list-tile-sub-title>
                        {{listing | originName}}
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-flex style="padding-left: 10px;" v-if="isPickupAdminViewing">
                    <v-btn @click="$router.push({ path: `/companies/${pickupCompany.id}/profile`})">
                      <v-icon left>business</v-icon>
                      {{ pickupCompany.name }} Profile
                    </v-btn>
                  </v-flex>
                  <company-profile-card  v-if="currentLoad"
                                         :load="currentLoad"
                                         :role="LoadCompanyRole.OriginStockyard">
                  </company-profile-card>
                </v-list-group>

                <v-list-group>
                  <v-list-tile slot="activator">
                    <v-list-tile-content>
                      <v-list-tile-title>
                        <b>Destination</b>
                      </v-list-tile-title>
                      <v-list-tile-sub-title>
                        {{listing | destinationName}}
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-flex style="padding-left: 10px;" v-if="isDropoffAdminViewing">
                    <v-btn @click="$router.push({ path: `/companies/${dropoffCompany.id}/profile`})">
                      <v-icon left>business</v-icon>
                      {{ dropoffCompany.name }} Profile
                    </v-btn>
                  </v-flex>
                  <company-profile-card v-if="currentLoad"
                                        :load="currentLoad"
                                        :role="LoadCompanyRole.DestinationStockyard">
                  </company-profile-card>
                </v-list-group>

                <v-list-group v-if="driverSectionTitle">
                  <v-list-tile slot="activator">
                    <v-list-tile-content>
                      <v-list-tile-title>
                        <b>{{ driverSectionTitle }}</b>
                      </v-list-tile-title>
                      <v-list-tile-sub-title v-if="loadModel.assignedTruckingCompanyDriverName(currentLoad)">
                        <bqa-certificate-icon small :driver="driver"></bqa-certificate-icon>
                        {{loadModel.assignedTruckingCompanyDriverName(currentLoad)}}
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <template v-if="driver">
                    <v-list-tile>
                      <v-list-tile-action>
                        <v-icon class="mr-2">email</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <a :href="`mailto:${driver.contactEmail}`">
                          {{driver.contactEmail}}
                        </a>
                      </v-list-tile-content>
                    </v-list-tile>

                    <v-list-tile>
                      <v-list-tile-action>
                        <v-icon class="mr-2">phone</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <a :href="`tel:${driver.contactPhone}`">
                          {{driver.contactPhone}}
                        </a>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile>
                      <v-list-tile-avatar :size="30">
                        <bqa-certificate-icon responsive :driver="driver"></bqa-certificate-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content v-if="_.get(driver,'bqaCertification.expires', false)">
                        <v-list-tile-title>
                          Expiration date
                        </v-list-tile-title>
                        <v-list-tile-sub-title>
                          {{driver.bqaCertification.expires | formatDay}}
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-tile-content v-else>
                        <v-list-tile-title>
                          Not Provided
                        </v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </template>

                  <v-list-tile v-if="canAssignDriver">
                    <v-list-tile-action>
                      <v-icon color="primary">headset_mic</v-icon>
                    </v-list-tile-action>
                    <v-select-load-driver @refresh="$emit('updateLoad', $event)"
                                          :load="currentLoad"
                                          :company="company">
                    </v-select-load-driver>
                  </v-list-tile>
                </v-list-group>

                <v-list-group v-if="hasBidHistory || customerSettlement || freightSettlement">
                  <v-list-tile slot="activator">
                    <v-list-tile-content>
                      <v-list-tile-title>
                        <b>Settlement</b>
                      </v-list-tile-title>
                      <v-list-tile-sub-title
                        v-if="_.get(customerSettlement, 'billOfLadingNumber', false)">
                    <span class="font-italic">
                      {{ $t('terms.bill-of-lading') }}: {{_.get(customerSettlement, 'billOfLadingNumber')}}
                    </span>
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-layout v-if="_.get(customerSettlement, 'billOfLadingNumber') && !_.get(currentLoad, 'billOfLading.link', false)">
                    <v-list-tile>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          Retry Creating the {{ $t('terms.bill-of-lading') }}
                        </v-list-tile-title>
                        <v-list-tile-sub-title>
                          Attempt to Create the {{ $t('terms.bill-of-lading') }} with attached images again
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-btn flat color="accent" class="pl-1 pr-1" @click="requestRedoBillOfLading(customerSettlement)">
                          <v-icon class="pr-2">refresh</v-icon>
                          Redo BoL
                        </v-btn>
                      </v-list-tile-action>
                    </v-list-tile>
                  </v-layout>
                  <v-layout class="pl-3 pr-3" wrap justify-start>
                    <v-list three-line dense>
                      <template v-if="hasBidHistory">
                        <v-subheader>Bid History</v-subheader>
                        <!-- mobile Card -->
                        <v-card v-if="$vuetify.breakpoint.smAndDown">
                          <v-card-title>
                            <div>
                              <p>
                                <b>Winning bid {{_.get(currentLoad, 'bid.humanId')}}</b>
                              </p>
                              <p>
                                ${{_.get(currentLoad, 'bid.amount')}}
                                <span class="font-italic">billed to {{$t('components.load-details.self-contracted').toLocaleLowerCase()}}</span>
                              </p>
                            </div>
                          </v-card-title>

                          <v-card-actions>
                            <v-icon class="pa-2" color="accent">gavel</v-icon>
                            <v-spacer></v-spacer>
                            <v-btn color="accent pr-2"
                                   @click="openBidTimelineDialog(currentLoad.bid)">
                              <v-icon class="mr-2">chat</v-icon>
                              Review
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                        <v-list-tile v-else avatar>
                          <v-list-tile-content>
                            <v-list-tile-title>
                              <b>Winning bid {{_.get(currentLoad, 'bid.humanId')}}</b>
                            </v-list-tile-title>
                            <!-- seems that here, we need to see if this is dispatched or a direct load -->
                            <v-list-tile-sub-title>
                              ${{_.get(currentLoad, 'bid.amount')}}
                              <span class="font-italic">billed to {{$t('components.load-details.self-contracted').toLocaleLowerCase()}}</span>
                            </v-list-tile-sub-title>
                          </v-list-tile-content>

                          <v-list-tile-action>
                            <v-list-tile-action-text>
                              <v-layout column>
                                <v-icon class="pa-2" color="accent">gavel</v-icon>
                                <v-btn color="accent pr-2"
                                       small
                                       @click="openBidTimelineDialog(currentLoad.bid)">
                                  <v-icon class="pa-2">chat</v-icon>
                                  Review
                                </v-btn>
                              </v-layout>
                            </v-list-tile-action-text>
                          </v-list-tile-action>
                        </v-list-tile>


                        <v-divider></v-divider>
                      </template>

                      <template v-if="customerSettlement">
                        <v-subheader>Billed to Customer</v-subheader>
                        <settlement-card :settlement-item="customerSettlement"
                                         :invoicing-company="customerSettlementInvoicingCompany || {}"
                                         @open-timeline="openTimelineDialog($event)"
                                         @refresh="refreshCurrentLoad"
                                         @redoBoL="openTimelineDialog($event)">
                        </settlement-card>
                        <v-divider></v-divider>
                      </template>

                      <v-subheader v-if="freightSettlement && freightSettlement.length">
                        Freight
                      </v-subheader>

                      <template v-for="(settlementItem, index) in freightSettlement">
                        <settlement-card :settlement-item="settlementItem"
                                         :invoicing-company="loadCompanies[settlementItem.paidToCompanyId] || {}"
                                         @open-timeline="openTimelineDialog($event)"
                                         @refresh="refreshCurrentLoad"
                                         :key="index+'_settlement'">
                        </settlement-card>
                      </template>
                    </v-list>
                  </v-layout>
                </v-list-group>
                <v-list-tile v-if="_.get(currentLoad, 'delivery.billOfLadingNumber', false)">
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <b>{{ $t('terms.bill-of-lading') }} Number: </b>
                      <span class="font-italic">
                        {{currentLoad.delivery.billOfLadingNumber}}
                       </span>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>

              <template v-if="$vuetify.breakpoint.smAndDown">
                <load-map
                  class="py-2 px-3"
                  hideOnSmall
                  :load="currentLoad"
                  :position-markers="checkinEvents"
                  :origin-place-id="originPlaceId"
                  :destination-place-id="destinationPlaceId">
                </load-map>
              </template>
            </v-card>
          </v-flex>
          <v-flex md6 v-if="!$vuetify.breakpoint.smAndDown">
            <v-card>
              <load-map
                :load="currentLoad"
                :position-markers="checkinEvents"
                :origin-place-id="originPlaceId"
                :destination-place-id="destinationPlaceId">
              </load-map>

              <p class="my-0 px-2 py-2 text-lg-center text-md-center">
                {{distanceLabel(loadModel.loadedMiles(currentLoad))}}. Based on Google Maps
              </p>
            </v-card>
          </v-flex>
        </v-layout>

        <v-layout column>
          <v-layout class="my-2">
            <v-icon @click="getFulfillment()">timeline</v-icon>
            <div class="headline ml-2">Load History</div>
            <v-spacer />
          </v-layout>

          <v-card>
            <v-layout wrap class="px-4 py-2" justify-space-between>
              <div class="subheading">Fulfillment Timeline</div>
            </v-layout>
            <v-layout wrap flex-end class="px-4 py-2">
              <v-flex class="mx-1" >
                <input type="file" style="" ref="inpsectionPapersAttachment"
                       multiple hidden @change="processInspectionPapers($event)"/>
                <v-btn block class="primary" @click="openInspectionPapersSelector">
                  Upload Inspection Papers
                </v-btn>
              </v-flex>
              <v-flex class="ml-1" >
                <v-layout>
                  <v-flex xs10 sm10 md10>
                    <v-badge right color="accent">
                      <template slot="badge">
                        <v-icon dark @click="openPhotoHelpDialog = true">help</v-icon>
                      </template>
                      <v-btn block class="primary" @click="openPhotoUploadModal('fulfillment')">
                        Upload Photo
                      </v-btn>
                    </v-badge>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout row class="px-4 py-2">
              <v-layout justify-start>
                <v-flex sm10 xs8>
                  <v-textarea block v-model="fulfillmentText"
                              :rows="2"
                              label="Type something...">
                  </v-textarea>
                  <!--                <v-progress-linear v-if="uploadProgressPercentage !== null"-->
                  <!--                                   color="primary"-->
                  <!--                                   class="mt-0 pt-0"-->
                  <!--                                   v-model="uploadProgressPercentage">-->
                  <!--                </v-progress-linear>-->
                </v-flex>
                <v-spacer />
                <v-flex sm2 xs4>
                  <v-btn block class="mr-0 px-0"
                         :loading="loadingBtn" :disabled="loadingBtn"
                         @click="sendFulfillmentMessage">Send</v-btn>
                </v-flex>
              </v-layout>
            </v-layout>
            <v-layout column wrap class="px-4 py-2">
              <timeline v-if="fulfillmentTimeline && currentLoad"
                        :load="currentLoad"
                        :timeline-object="fulfillmentTimeline"></timeline>
            </v-layout>
            <v-layout column wrap class="px-4 py-2" align-end>
              <v-flex v-if="_.get(currentLoad, 'inspectionPapers.link', false) ||
                        _.get(currentLoad, 'billOfLading.link', false) ||
                        fulfillmentAttachmentEvents.length">
                <b>Attachments</b></v-flex>
              <v-btn class="primary--text mx-0 px-0" flat @click="openInspectionPapers"
                     v-if="_.get(currentLoad, 'inspectionPapers.link', false)">
                <v-icon color="primary">attachment</v-icon>
                View Inspection Papers
              </v-btn>

              <v-btn class="primary--text mx-0 px-0" flat @click="openBillOfLading"
                     v-if="_.get(currentLoad, 'billOfLading.link', false)">
                <v-icon color="primary">attachment</v-icon>
                View {{ $t('terms.bill-of-lading') }}
              </v-btn>

              <v-layout :key="`fulfil-event-${idx}`"
                        v-for="(attachmentEvent, idx) in fulfillmentAttachmentEvents">
                <v-btn class="primary--text mx-0 px-0" flat @click="openAttachment(attachmentEvent)">
                  <v-icon color="primary">attachment</v-icon>
                  {{ attachmentEvent.message }} ({{attachmentEvent.timestamp | formatDate }})
                </v-btn>
              </v-layout>
            </v-layout>
          </v-card>
        </v-layout>
      </div>
    </v-layout>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import API from '@/api';
import TheCard from '@/components/TheCard';
import Timeline from '@/components/timeline/Timeline';
import ProgressArrows from '@/components/ProgressArrows2';
import CompanyProfileCard from '@/components/CompanyProfileCard';
import VFloatField from '@/components/VFloatField';
import { mapState, mapGetters } from 'vuex';
import { UserPerm, LoadCompanyRole, Originations, timelineEvent } from '@/types';
import companyNamesMixin from '@/mixins/companyNames';
import checkinEventsUtils from '@/mixins/checkinEventsUtils';
import refreshPageMixin from '@/mixins/refreshPageMixin';
import bookedLoadMixin from '@/mixins/bookedLoadMixin';

import Model from '@/types/models/';
import LoadMap from '@/components/LoadMap';
import VSelectLoadDriver from '@/components/SelectLoadDriver';
import Toolbar from '@/components/Toolbar';
import IconBase from '@/components/IconBase';
import IconHose from '@/components/icons/IconHose';
import IconWood from '@/components/icons/IconWood';
import IconCold from '@/components/icons/IconCold';
import * as types from '@/store/mutationTypes';
import * as Checks from '@/store/permissions';
import * as Loads from '@/types/models/load';
import { driversWithCDN } from '@/types/models/company';

import PickupLoadDialog from '@/components/modals/PickupLoadDialog';
import DeliverLoadDialog from '@/components/modals/DeliverLoadDialog';
import UploadBillOfLadingDialog from '@/components/modals/UploadBillofLadingDialog';
import CancelLoadDialog from '@/components/modals/CancelLoadDialog';
import DatePicker from '@/components/DatePicker';

import VRepeatLoadGroupDialog from '@/components/RepeatLoadGroupDialog';
import UpdateEtaDialog from '@/components/modals/UpdateEtaDialog';
import DispatcherInfo from '@/components/qb/DispatcherInfo';

import SettlementCard from './SettlementCard';
import BqaCertificateIcon from '../../BqaCertificateIcon';
import unitsOfMeasurePlugin from '../../../mixins/unitsOfMeasurePlugin';

export default {
  name: 'LoadDetail',
  mixins: [
    bookedLoadMixin,
    companyNamesMixin,
    checkinEventsUtils,
    refreshPageMixin,
    unitsOfMeasurePlugin,
  ],
  props: {
    currentLoad: {
      type: Object, // this is a V1 load API object
      required: true,
    },
    company: {
      type: Object,
      required: true,
    },
    embedded: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
    },
  },
  data: () => ({
    reqListGroup: true,
    viewToggle: 'text',
    tab: null,
    loadingDeliveredBtn: false,
    showCopyLoadDialog: false,
    showPickupDialog: false,
    showDeliverDialog: false,
    showAttachPhotoDialog: false,
    showAttachBillOfLadingDialog: false,
    showTimelineDialog: false,
    timelineDialogBid: null,
    timelineDialogSettlement: null,
    loadStatus: null,
    estimatedDeliveryTime: '',
    estimatedTimeMenu: false,
    billOfLadingNumber: '',
    pickupTime: '',
    trailerIdentifier: '',
    truckIdentifier: '',
    comment: '',
    fulfillmentTimeline: { events: [], participants: [] },
    dialogTimeline: null,
    fulfillmentText: '',
    bidText: '',
    settlementText: '',
    showUpdateETADialog: false,
    etaUpdateToType: '',
    loadingBtn: false,
    attachedPhotoName: '',
    uploadProgressPercentage: null,
    driver: null,
    openPhotoHelpDialog: false,
    listingCompanyProfile: null,
    truckingCompanyProfile: null,
    pickupCompanyProfile: null,
    dropoffCompanyProfile: null,
    cancelModal: false,
    loadingData: false,
  }),
  components: {
    BqaCertificateIcon,
    UpdateEtaDialog,
    CancelLoadDialog,
    UploadBillOfLadingDialog,
    VRepeatLoadGroupDialog,
    TheCard,
    Timeline,
    ProgressArrows,
    VFloatField,
    IconBase,
    IconHose,
    IconWood,
    IconCold,
    LoadMap,
    CompanyProfileCard,
    Toolbar,
    SettlementCard,
    PickupLoadDialog,
    DeliverLoadDialog,
    DatePicker,
    VSelectLoadDriver,
    DispatcherInfo,
  },
  computed: {
    _() {
      return _;
    },
    hasCompanyProfile() {
      return !!_.get(this.loadModel.customerCompany(this.currentLoad), 'id', false);
    },
    loadGroupId() {
      return this.listing.listingHumanId || this.loadGroup.humanId;
    },
    assignedVendor() {
      return this.bookedLoadVendorCarrierCompany(this.currentLoad);
    },
    listing() {
      return Loads.listingDetails(this.currentLoad);
    },
    tacticalInfo() {
      return _.get(this.currentLoad, 'tacticalInfo', {});
    },
    mapHolder() {
      // Loads model attribute lookup will initialize loadDetails to {}, which doesn't help us detect object version here
      return this.tacticalInfo.loadDetails || this.tacticalInfo.loadGroup.details;
    },
    originPlaceId() {
      return _.get(this.mapHolder, 'pickupLocation.googlePlace.placeId', null);
    },
    destinationPlaceId() {
      return _.get(this.mapHolder, 'dropoffLocation.googlePlace.placeId', null);
    },
    originPlaceLabel() {
      return _.get(this.mapHolder, '.pickupLocation.googlePlace.placeName', '');
    },
    destinationPlaceLabel() {
      return _.get(this.mapHolder, 'dropoffLocation.googlePlace.placeName', '');
    },
    isDispatched() {
      return _.get(this.currentLoad, 'origination', '') === Originations.DISPATCHED;
    },
    listingSponsorName() {
      return this.listingCustomerName(this.listing) || this.listingProducerName(this.listing);
    },
    ...mapState('companies', [
      'companies',
    ]),
    ...mapState('profiles', {
      userProfile: 'userProfile',
    }),
    ...mapGetters('profiles', {
      isLtnAdmin: 'isLtnAdmin',
    }),
    checkinEvents() {
      return this.formatCheckinEvents(this.fulfillmentTimeline.events,
        this.fulfillmentTimeline.participants);
    },
    loadId() {
      return this.currentLoad.id;
    },
    listingCompany() {
      // Loads model attribute lookup will initialize loadDetails to {}, which doesn't help us detect object version here
      const groupCo = _.get(this.loadGroup, 'details.listingCompany', {});
      return _.get(this.currentLoad, 'tacticalInfo.loadDetails.listingCompany', groupCo);
    },
    haulingCompany() {
      return Loads.haulingCompany(this.currentLoad) || {};
    },
    truckingCompany() {
      return Loads.carrierCompany(this.currentLoad) || {};
    },
    pickupCompany() {
      // Loads model attribute lookup will initialize loadDetails to {}, which doesn't help us detect object version here
      const groupCo = _.get(this.loadGroup, 'details.pickupCompany', {});
      return _.get(this.currentLoad, 'tacticalInfo.loadDetails.pickupCompany', groupCo) || {};
    },
    dropoffCompany() {
      // Loads model attribute lookup will initialize loadDetails to {}, which doesn't help us detect object version here
      const groupCo = _.get(this.loadGroup, 'details.dropoffCompany', {});
      return _.get(this.currentLoad, 'tacticalInfo.loadDetails.dropoffCompany', groupCo) || {};
    },
    loadDetails() {  // this is V1 API object
      return Loads.listingDetails(this.currentLoad);
    },
    // support V2 load
    loadGroup() {
      return _.get(this.currentLoad, 'tacticalInfo.loadGroup', {});
    },
    hasBidHistory() {
      return _.get(this.currentLoad, 'bid.id', false);
    },
    fulfillmentAttachmentEvents() {
      return _.filter(this.fulfillmentTimeline.events, event => _.get(event, 'mediaMessage.link', false));
    },
    producerAccount() {
      return this.findCompanyAccount()(this.listingCompany.id);
    },
    carrierAccount() {
      return this.findCompanyAccount()(this.truckingCompany.id);
    },
    isListingCompanyOfficeViewing() {
      return Checks.accountHasOfficePermission(this.producerAccount);
    },
    isProducerWithPermissions() {
      return Checks.accountHasOfficePermission(this.producerAccount);
    },
    isListingCompanyAdminViewing() {
      const permissions = _.get(this.producerAccount, 'companyPermissions', []);
      return permissions.includes(UserPerm.PERM_ADMIN);
    },
    isTruckingCompanyViewing() {
      const permissions = _.get(this.carrierAccount, 'companyPermissions', []);
      const remaining = permissions.filter(element => element !== UserPerm.PERM_LOAD_ASSIGN);

      return remaining && remaining.length > 0;
    },
    isTruckingDriverViewing() {
      const driverId = _.get(this.tacticalInfo, 'assignedTruckingCompanyDriverUserId', false);
      return driverId && this.userProfile.id === driverId;
    },
    isTruckingOfficeViewing() {
      return Checks.accountHasOfficePermission(this.carrierAccount);
    },
    isTruckingAdminViewing() {
      const permissions = _.get(this.carrierAccount, 'companyPermissions', []);
      return permissions.includes(UserPerm.PERM_ADMIN);
    },
    isDispatchedVendorViewing() {
      return Checks.canProfileDeliverLoad(this.userProfile, this.currentLoad.humanId);
    },
    isPickupAdminViewing() {
      const originAccount = this.findCompanyAccount()(this.pickupCompany.id);
      const permissions = _.get(originAccount, 'companyPermissions', []);
      return permissions.includes(UserPerm.PERM_ADMIN);
    },
    isDropoffAdminViewing() {
      const dropoffAccount = this.findCompanyAccount()(this.dropoffCompany.id);
      const permissions = _.get(dropoffAccount, 'companyPermissions', []);
      return permissions.includes(UserPerm.PERM_ADMIN);
    },
    isFinancialStakeholderViewing() {
      return this.isLtnAdmin ||
        Checks.accountHasCreateListingPermission(this.producerAccount) ||
        Checks.accountHasFinancialPermission(this.carrierAccount) ||

        Checks.accountHasOfficePermission(this.producerAccount);
    },
    drivers() {
      return driversWithCDN(this.company);
    },
    canAssignDriver() {
      return this.isTruckingOfficeViewing &&
        (this.isScheduled || this.isInTransit) &&
        this.drivers.length;
    },
    driverSectionTitle() {
      const currentDriver = _.get(this.currentLoad, 'tacticalInfo.assignedTruckingCompanyDriverName', false);

      // if I can't _assign_ and no driver is assigned then there's nothing more to say.
      if (!this.isTruckingOfficeViewing && !currentDriver) {
        return null;
      }

      let prefix = '';
      if (this.canAssignDriver) {
        prefix = currentDriver ? 'Reassign ' : 'Assign ';
      }

      if (this.canAssignDriver || currentDriver) {
        return `${prefix}Driver`;
      }

      return !_.isEmpty(this.driver);
    },
    canViewLoadSettlement() {
      return _.get(this.userProfile, 'companyAccounts', []).some((account) => {
        return Checks.canAccountViewCompanyLoadSettlements(account);
      });
    },
    canUpdateLoadProgress() {
      return this.isListingCompanyOfficeViewing ||
        this.isTruckingCompanyViewing ||
        this.isTruckingDriverViewing ||
        this.isDispatchedVendorViewing ||
        this.isLtnAdmin;
    },
    progressIcon() {
      return this.bookedLoadProgressIcon(this.currentLoad);
    },
    currentLoadStatus() {
      return this.bookedLoadStatus(this.currentLoad);
    },
    isScheduled() {
      return this.isBookedLoadScheduled(this.currentLoad);
    },
    isInTransit() {
      return this.isBookedLoadInTransit(this.currentLoad);
    },
    isDelivered() {
      return this.isBookedLoadDelivered(this.currentLoad);
    },
    isFinalized() {
      return this.isBookedLoadFinalized(this.currentLoad);
    },
    isCanceled() {
      return this.isBookedLoadCanceled(this.currentLoad);
    },
    canCancel() {
      return (!this.isCanceled && this.isLtnAdmin) ||
        (this.isProducerWithPermissions &&
          !this.isCanceled && (this.isInTransit || this.isScheduled));
    },
    gMapsLink() {
      const originLabel = this.originPlaceLabel;
      const originId = this.originPlaceId;
      const destinationLabel = this.destinationPlaceLabel;
      const destinationId = this.destinationPlaceId;
      return `https://www.google.com/maps/dir/?api=1&origin=${originLabel}&origin_place_id=${originId}&destination=${destinationLabel}&destination_place_id=${destinationId}`;
    },
    requireWashout() {
      return Loads.requiresWashout(this.currentLoad);
    },
    requireWeatherboards() {
      return Loads.requireWeatherboards(this.currentLoad);
    },
    requireWoodChips() {
      return Loads.requireWoodChips(this.currentLoad);
    },
    dispatchInstructions() {
      return Loads.dispatchInstructions(this.currentLoad);
    },
    pickedUpLocalTime() {
      return Loads.pickedUpLocalTime(this.currentLoad);
    },
    pickupEstimatedTime() {
      return Loads.pickupEstimated(this.currentLoad);
    },
    pickupScheduledTime() {
      return Loads.pickupScheduled(this.currentLoad);
    },
    notificationPickupTime() {
      return Loads.notificationPickupTime(this.currentLoad);
    },
    deliveredLocalTime() {
      return Loads.deliveredLocalTime(this.currentLoad);
    },
    deliveryEstimatedTime() {
      return Loads.deliveryEstimated(this.currentLoad);
    },
    notificationDeliveryTime() {
      return Loads.notificationDeliveryTime(this.currentLoad);
    },
    loadModel() {
      return Model.load;
    },
    LoadCompanyRole() {
      return LoadCompanyRole;
    },
    customerSettlement() {
      return Model.load.customerSettlement(this.currentLoad);
    },
    freightSettlement() {
      return Model.load.freightSettlement(this.currentLoad);
    },
    customerSettlementInvoice() {
      const settlement = this.customerSettlement;
      return Model.settlement.invoice(settlement);
    },
    customerSettlementInvoicingCompany() {
      const invoice = this.customerSettlementInvoice;
      const companyId = invoice.paidTo.id;

      if (_.get(this.listingCompanyProfile, 'id') === companyId) {
        return this.listingCompanyProfile;
      }

      if (_.get(this.truckingCompanyProfile, 'id') === companyId) {
        return this.truckingCompanyProfile;
      }

      if (_.get(this.pickupCompanyProfile, 'id') === companyId) {
        return this.pickupCompanyProfile;
      }

      if (_.get(this.dropoffCompanyProfile, 'id') === companyId) {
        return this.dropoffCompanyProfile;
      }

      return undefined;
    },
    loadCompanies() {
      const companies = {};
      if (this.listingCompanyProfile) {
        companies[this.listingCompanyProfile.id] = this.listingCompanyProfile;
        companies[this.listingCompanyProfile.id.toString()] = this.listingCompanyProfile;
      }
      if (this.truckingCompanyProfile) {
        companies[this.truckingCompanyProfile.id] = this.truckingCompanyProfile;
        companies[this.truckingCompanyProfile.id.toString()] = this.truckingCompanyProfile;
      }
      if (this.pickupCompanyProfile) {
        companies[this.pickupCompanyProfile.id] = this.pickupCompanyProfile;
        companies[this.pickupCompanyProfile.id.toString()] = this.pickupCompanyProfile;
      }
      if (this.dropoffCompanyProfile) {
        companies[this.dropoffCompanyProfile.id] = this.dropoffCompanyProfile;
        companies[this.dropoffCompanyProfile.id.toString()] = this.dropoffCompanyProfile;
      }

      return companies;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  watch: {
    loading(newVal) {
      this.loadingBtn = newVal;
    },
    currentLoad: {
      handler(currentLoad, oldLoad) {
        if (_.get(currentLoad, 'billOfLading.link', null)) {
          if (this.$route.query.view === 'doc:bol') {
            const query = _.clone(this.$route.query);
            delete query.view;
            this.$router.replace({ query });

            this.openBillOfLading();
          }
        }

        // load was updated. let's get the history and the settlements and stuff
        if (currentLoad.humanId !== oldLoad.humanId) {
          this.fulfillmentTimeline = { events: [], participants: [] };
          this.getFulfillment();
          this.fulfillmentText = '';
        }

        this.loadCompaniesProfile();
        this.updateDriverInfo();
      },
      deep: true,
    },
  },
  methods: {
    updateDriverInfo() {
      this.driver = null;
      const driverUserId = _.get(this.tacticalInfo, 'assignedTruckingCompanyDriverUserId', null);
      if (driverUserId) {
        // const driverResponse = await API.user.getUserProfile({ userId: driverUserId });
        // this.driver = driverResponse.data;
        API.user.getUserProfile({ userId: driverUserId }).then((driverResponse) => {
          this.driver = driverResponse.data;
        });
      }
    },
    openTimelineDialog(settlement) {
      this.showTimelineDialog = true;
      this.timelineDialogSettlement = settlement;
      this.timelineDialogBid = null;
      this.getTimeline(API.settlements.getTimeline(settlement.id));
    },
    openBidTimelineDialog(bid) {
      this.showTimelineDialog = true;
      this.timelineDialogBid = bid;
      this.timelineDialogSettlement = null;
      this.getTimeline(API.bid.getConversation({ bidId: bid.id }));
    },
    closeTimelineDialog() {
      this.timelineDialogSettlement = null;
      this.timelineDialogBid = null;
      this.dialogTimeline = null;
      this.showTimelineDialog = false;
    },
    openCopyLoadDialog() {
      this.showCopyLoadDialog = true;
    },
    closeCopyLoadDialog(success) {
      this.showCopyLoadDialog = false;
      console.log('closeCopyLoadDialog');
      if (success) {
        console.log('Show planner');
        // Show planning section
        this.$router.push({
          name: 'company.loads.planner',
          params: {
            id: this.company.id,
          },
        });
      }
    },
    async getTimeline(loadTimeline) {
      try {
        this.loadingData = true;
        const response = await loadTimeline;
        this.dialogTimeline = response.data;
      } catch (error) {
        if (error.status !== 404) {
          this.$store.dispatch('applications/setErrorNotification', {
            message: error.message,
          });
        }
      } finally {
        this.loadingData = false;
      }
    },
    openPhotoUploadModal(type) {
      this.showAttachPhotoDialog = true;
      this.photoUploadType = type;
    },
    getPropertyColumnValue(item, columnName, path, failValue) {
      const propertyColumn = item.find(column => column.headerName === columnName);
      if (!propertyColumn) {
        return failValue || null;
      }
      return _.get(propertyColumn, path, failValue || null);
    },
    ...mapGetters('profiles', {
      findCompanyAccount: 'findCompanyAccount',
    }),
    openUpdateETADialog(type) {
      this.etaUpdateToType = type;
      this.showUpdateETADialog = true;
    },
    async sendFulfillmentMessage() {
      try {
        this.loadingBtn = true;
        await API.load.updateFulfillment({
          loadId: this.currentLoad.id,
          messageRequest: {
            message: this.fulfillmentText,
            sent: new Date().toISOString(),
          },
        });

        this.getFulfillment();
        this.fulfillmentText = '';
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message,
        });
      } finally {
        this.loadingBtn = false;
      }
    },
    async sendSettlementMessage(settlementId) {
      try {
        this.loadingBtn = true;
        await API.settlements.sendMessage({
          settlementId,
          messageRequest: {
            message: this.settlementText,
            sent: new Date().toISOString(),
          },
        });

        this.getTimeline(API.settlements.getTimeline(settlementId));
        this.settlementText = '';
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message,
        });
      } finally {
        this.loadingBtn = false;
      }
    },
    async getLoad(params) {
      await API.load.getLoad(params);
    },
    async getFulfillment() {
      const response = await API.load.getFulfillment({ loadId: this.currentLoad.id });
      this.fulfillmentTimeline = response.data;
    },
    openDeliverDialog() {
      this.showDeliverDialog = true;
    },
    displayCancelModal() {
      this.cancelModal = true;
    },
    removeLoad() {
      this.$emit('removeLoad', this.currentLoad.humanId);
    },
    onRefresh() {
      // this is what the timer calls. so do something timely.
      this.refreshCurrentLoad();
    },
    refreshCurrentLoad() {
      this.$emit('refreshLoad', this.currentLoad.humanId);
      this.getFulfillment();
    },
    loadCompaniesProfile() {
      if (this.listingCompany) {
        API.company.byId({ id: this.listingCompany.id }).then((apiResponse) => {
          this.listingCompanyProfile = apiResponse.data;
        });
      }

      if (this.truckingCompany && this.truckingCompany.id) {
        API.company.byId({ id: this.truckingCompany.id }).then((apiResponse) => {
          this.truckingCompanyProfile = apiResponse.data;
        });
      }

      if (_.get(this.pickupCompany, 'id', false)) {
        API.company.byId({ id: this.pickupCompany.id }).then((apiResponse) => {
          this.pickupCompanyProfile = apiResponse.data;
        });
      }

      if (_.get(this.dropoffCompany, 'id', false)) {
        API.company.byId({ id: this.dropoffCompany.id }).then((apiResponse) => {
          this.dropoffCompanyProfile = apiResponse.data;
        });
      }
    },
    openFileSelector(refId) {
      this.$refs[refId].click();
    },
    openInspectionPapersSelector() {
      this.$refs.inpsectionPapersAttachment.click();
    },
    openPhotoAttachmentSelector() {
      this.$refs.photoAttachment.click();
    },
    async processSettlementAttachment(event, settlementId) {
      try {
        this.$store.commit(`applications/${types.START_LOADING}`);
        const getBase64ApiCalls = [];
        for (var i = 0; i < event.target.files.length; i++) {
          getBase64ApiCalls.push(await this.getBase64(event.target.files[i]));
        }

        const base64s = await Promise.all([
          getBase64ApiCalls,
        ]);

        await API.settlements.uploadSettlementFile({
          settlementId,
          base64s,
          message: this.settlementText,
        });

        this.getTimeline(API.settlements.getTimeline(settlementId));
        this.settlementText = '';
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message,
        });
      } finally {
        this.$store.commit(`applications/${types.END_LOADING}`);
      }
    },
    async processInspectionPapers(event) {
      try {
        const getBase64ApiCalls = [];
        for (var i = 0; i < event.target.files.length; i++) {
          getBase64ApiCalls.push(await this.getBase64(event.target.files[i]));
        }

        this.uploadProgressPercentage = 0;

        const uploading = {
          event: timelineEvent.UPLOADING_FILE,
          timestamp: moment(),
          percent: this.uploadProgressPercentage,
        };
        this.fulfillmentTimeline.events.unshift(uploading);

        const config = {
          onUploadProgress: (progressEvent) => {
            this.uploadProgressPercentage = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            uploading.percent = this.uploadProgressPercentage;
          },
        };

        const inspectionPapersBase64s = await Promise.all([
          getBase64ApiCalls,
        ]);

        await API.load.uploadInspectionPapers({
          inspectionPapersBase64s,
          loadId: this.currentLoad.humanId,
          config,
        });

        this.refreshCurrentLoad();
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message,
        });
      } finally {
        this.uploadProgressPercentage = null;
      }
    },
    async processPhotoAttachment(event) {
      try {
        const getBase64ApiCalls = [];
        for (var i = 0; i < event.target.files.length; i++) {
          getBase64ApiCalls.push(await this.getBase64(event.target.files[i]));
        }

        this.uploadProgressPercentage = 0;

        const uploading = {
          event: timelineEvent.UPLOADING_FILE,
          percent: this.uploadProgressPercentage,
        };
        this.fulfillmentTimeline.events.unshift(uploading);

        const config = {
          onUploadProgress: (progressEvent) => {
            this.uploadProgressPercentage = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            uploading.percent = this.uploadProgressPercentage;
          },
        };

        const photoBase64s = await Promise.all([
          getBase64ApiCalls,
        ]);
        switch (this.photoUploadType) {
          case 'fulfillment': {
            await API.load.uploadFulfillmentPhoto({
              photoBase64s,
              name: this.attachedPhotoName,
              loadId: this.currentLoad.id,
              config,
            });
            break;
          }
          case 'settlement': {
            await API.load.uploadSettlementPhoto({
              photoBase64s,
              name: this.attachedPhotoName,
              loadId: this.currentLoad.id,
              config,
            });
            break;
          }
          case 'bid': {
            await API.bid.uploadBidPhoto({
              photoBase64s,
              name: this.attachedPhotoName,
              bidId: this.currentLoad.bid.id,
              config,
            });
            break;
          }
          default:
        }
        this.refreshCurrentLoad();
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message,
        });
      } finally {
        this.showAttachPhotoDialog = false;
        this.attachedPhotoName = '';
        this.uploadProgressPercentage = null;
        this.photoUploadType = '';
      }
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    async openBillOfLading() {
      const url = this.currentLoad.billOfLading.link;
      this.$store.dispatch('lightbox/show', url);
    },
    async openInspectionPapers() {
      const url = this.currentLoad.inspectionPapers.link;
      this.$store.dispatch('lightbox/show', url);
    },
    async openAttachment(attachmentEvent) {
      const url = _.get(attachmentEvent, 'mediaMessage.link', []);
      this.$store.dispatch('lightbox/show', url);
    },
    async checkIn() {
      this.loadingBtn = true;
      this.$store.commit(`applications/${types.START_LOADING}`);
      try {
        const userPosition = await API.map.getUserPosition();
        await API.load.checkIn({
          loadId: this.loadId,
          lat: _.get(userPosition, 'latitude', null),
          lng: _.get(userPosition, 'longitude', null),
          timestamp: new Date().toISOString(),
        });
        this.$store.dispatch('applications/setSuccessNotification', {
          message: 'Checked In successfully!',
        });
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message,
        });
      } finally {
        this.loadingBtn = false;
        this.$store.commit(`applications/${types.END_LOADING}`);
      }
    },
    async requestRedoBillOfLading(settlement) {
      this.loadingBtn = true;
      this.loadingData = true;
      try {
        await API.load.redoBOL({ loadId: settlement.loadHumanId });
        this.refreshItem(settlement);
      } finally {
        this.loadingBtn = false;
        this.loadingData = false;
      }
    },
    listingCustomerName(listing) {
      return _.get(listing, 'customerCompany.name');
    },
    listingProducerName(listing) {
      return _.get(listing, 'listingCompany.name');
    },
  },
  created() {
    window.__insp.push(['tagSession', 'open_load_detail']);
    this.$ga.event({
      eventCategory: 'open_section',
      eventAction: 'load_detail',
      eventLabel: this.loadId,
    });

    this.updateDriverInfo();
    this.getFulfillment();

    this.loadCompaniesProfile();
  },
};
</script>

<style scoped>
  a {
    text-decoration:none;
  }

  .desktop-list {
    min-height: 437px;
  }

  .scroll-section {
    height: calc(100vh - 244px);
    overflow: auto;
  }
</style>

<style>
  @media only screen and (max-width: 959px) {
    .deliver-dialog .v-stepper:not(.v-stepper--vertical) .v-stepper__label {
      display: flex;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/simple/LoadDetail.vue